if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.submitButton = this.querySelector(
          '[type="submit"]'
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (
          document.querySelector('cart-drawer') &&
          this.submitButton
        ) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) {
          return;
        }

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.error = false;

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add(
          'loading'
        );

        const spinner =
          this.querySelector(
            '.loading-overlay__spinner'
          );

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        /*
         * CREATE REQUEST
         */

        const config = fetchConfig(
          'javascript'
        );

        config.headers[
          'X-Requested-With'
        ] = 'XMLHttpRequest';

        delete config.headers[
          'Content-Type'
        ];

        /*
         * PRODUCT FORM DATA
         */

        const formData = new FormData(
          this.form
        );

        /*
         * IMPORTANT:
         *
         * Do NOT call:
         *
         * this.cart.getSectionsToRender()
         *
         * because that function belongs to
         * cart-items in this theme.
         */

        config.body = formData;

        /*
         * ADD PRODUCT TO SHOPIFY CART
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) => {
            return response.json();
          })

          .then((response) => {

            /*
             * SHOPIFY ERROR
             */

            if (response.status) {

              this.error = true;

              this.handleErrorMessage(
                response.description ||
                response.message ||
                'Unable to add this product to your cart.'
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {

                const buttonText =
                  this.submitButton.querySelector(
                    'span'
                  );

                if (buttonText) {
                  buttonText.classList.add(
                    'hidden'
                  );
                }

                soldOutMessage.classList.remove(
                  'hidden'
                );
              }

              return;
            }

            /*
             * PRODUCT SUCCESSFULLY ADDED
             */

            this.error = false;

            /*
             * UPDATE CART ICON COUNT
             *
             * We manually request the cart
             * bubble section because this theme's
             * cart-items owns getSectionsToRender().
             */

            fetch(
              `${routes.cart_url}?sections=cart-icon-bubble`,
              {
                headers: {
                  'X-Requested-With':
                    'XMLHttpRequest'
                }
              }
            )
              .then((response) => {
                if (!response.ok) {
                  throw new Error(
                    'Unable to update cart icon'
                  );
                }

                return response.json();
              })

              .then((sections) => {

                const cartBubble =
                  document.getElementById(
                    'cart-icon-bubble'
                  );

                if (
                  cartBubble &&
                  sections[
                    'cart-icon-bubble'
                  ]
                ) {

                  const newBubble =
                    new DOMParser()
                      .parseFromString(
                        sections[
                          'cart-icon-bubble'
                        ],
                        'text/html'
                      )
                      .querySelector(
                        '#cart-icon-bubble'
                      );

                  if (newBubble) {
                    cartBubble.innerHTML =
                      newBubble.innerHTML;
                  }
                }
              })

              .catch((error) => {
                console.error(
                  'Cart bubble update error:',
                  error
                );
              })

              .finally(() => {

                /*
                 * REDIRECT TO CART
                 *
                 * This guarantees the product
                 * is visible in the Shopify cart.
                 */

                window.location.href =
                  routes.cart_url;

              });
          })

          /*
           * REQUEST ERROR
           */

          .catch((error) => {

            console.error(
              'Add To Cart Error:',
              error
            );

            this.error = true;

            this.handleErrorMessage(
              'Unable to add this product to your cart. Please try again.'
            );
          })

          /*
           * FINISH
           */

          .finally(() => {

            this.submitButton.classList.remove(
              'loading'
            );

            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );

            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }
          });
      }

      /*
       * ERROR MESSAGE
       */

      handleErrorMessage(
        errorMessage = false
      ) {

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (
          errorMessage &&
          this.errorMessage
        ) {

          this.errorMessage.textContent =
            errorMessage;

        }
      }
    }
  );
}